// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MediaQuery from 'react-responsive';
import uuidv4 from 'uuid/v4';
import classNames from 'classnames/bind';

import more from '../../images/more.png';
import { CRAFTY_CLICKS_API_KEY } from '../../config/apiKeys';
import Input from '../Input/Input';
import styles from './styles';

class SearchInput extends Component {
  state = {
    openPopup: false,
  };

  static propTypes = {
    classes: PropTypes.object,
    postcode: PropTypes.string,
    changeField: PropTypes.func,
    searchAddress: PropTypes.func,
    addresses: PropTypes.array,
    requestSelectedAddress: PropTypes.func,
    style: PropTypes.string,
    left: PropTypes.bool,
  };

  static defaultProps = {
    classes: {},
    changeField: () => { },
    searchAddress: () => { },
    requestSelectedAddress: () => { },
    postcode: null,
    addresses: [],
    style: '',
    left: true,
  };

  componentDidMount() {
    const search = document.getElementById('tosearchPostcode');
    search.addEventListener('focusin', () => {
      this.setState({ openPopup: true });
    });
    search.addEventListener('focusout', () => {
      this.setState({ openPopup: false });
    });
  }

  onChangeSearchInput = (value) => {
    this.props.changeField(value, 'postcode');
    if (value.length > 0) {
      this.props.searchAddress({ query: value, key: CRAFTY_CLICKS_API_KEY, country: 'gbr' });
    }
  }

  cropText = (text, number) => {
    if (text.length < number) {
      return text;
    }
    return `${text.substr(0, number)}..`;
  }

  selectAddress = (el) => {
    if (el.count > 1) {
      this.props.searchAddress({
        query: this.props.postcode,
        key: CRAFTY_CLICKS_API_KEY,
        country: 'gbr',
        id: el.id,
      });
      setTimeout(() => document.getElementById('tosearchPostcode').focus(), 300);
    } else {
      this.props.requestSelectedAddress({ id: el.id, key: CRAFTY_CLICKS_API_KEY, country: 'gbr' });
    }
  }

  renderPopup = () => {
    const { classes, addresses, left } = this.props;

    return this.state.openPopup ? (
      <div className={classNames(classes.popup, left ? classes.left : null)}>
        {addresses.map((el, i) => (
          <button
            key={uuidv4()}
            onMouseDown={() => this.selectAddress(el)}
            id={`search-result-${i}`}
            className={classes.searchResult}
          >
            <span>
              <span className={classes.popupLabel}>{el.labels[0]}</span>
              {el.labels.length > 1 && (
                <MediaQuery minWidth={550}>
                  {matches => (matches
                    ? <span className={classes.popupLabel}>{this.cropText(el.labels[1], 50)}</span>
                    : (
                      <span className={classes.popupLabel}>
                        {this.cropText(el.labels[1], 25)}
                      </span>))}
                </MediaQuery>
              )}
            </span>
            {el.count > 1 && (
              <span className={classes.count}>
                <span>{`${el.count} more`}</span>
                <img src={more} alt={'more'} className={classes.more} />
              </span>)}
          </button>
        ))}
      </div>
    ) : null;
  }

  render() {
    const { classes, style } = this.props;
    return (
      <div className={classNames(style, classes.mainContainer)}>
        <Input
          label={'Search for your address:'}
          name={'searchPostcode'}
          placeholder={'Start typing postcode or street'}
          value={this.props.postcode}
          onChange={this.onChangeSearchInput}
          labelStyle={classes.labelStyle}
        />
        {this.renderPopup()}
      </div>
    );
  }
}

export default withStyles(styles)(SearchInput);
